import { graphConfig } from '../authConfig';

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */
export async function getProfileData (accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers: headers
  };

  return fetch(graphConfig.graphMeEndpoint, options)
    .then(response => response.json())
    .catch(error => console.log(error));
}

export async function getProfilePhoto (accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers: headers
  };

  return fetch(graphConfig.graphPhotoEndpoint, options)
    .then(response => response.blob())
    .catch(error => console.log(error));
}
